export function getAuthErrorMessage(error: any): string {
  // Map Supabase auth errors to user-friendly messages
  if (error?.message?.includes('Invalid login credentials')) {
    return 'Invalid email or password'
  }
  if (error?.message?.includes('Email not confirmed')) {
    return 'Please confirm your email address'
  }
  if (error?.message?.includes('User already registered')) {
    return 'An account with this email already exists'
  }
  if (error?.message?.includes('Password should be at least')) {
    return 'Password must be at least 6 characters'
  }
  if (error?.message?.includes('Unable to validate email')) {
    return 'Invalid email address'
  }
  if (error?.message?.includes('Email rate limit exceeded')) {
    return 'Too many attempts. Please try again later'
  }
  return error?.message || 'An error occurred. Please try again.'
}
